export default __webpack_public_path__ + "static/microsoft-bbb6b890a30e9cd3c0d6faa671a56509.svg";